import React from 'react';
import { CheckCircle } from 'lucide-react';
import TrustedInstitutions from '../components/TrustedInstitutions';

const Nosotros = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with World Map */}
      <section className="py-20 bg-gradient-to-br from-gray-100 to-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Notaria Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/de9lmz0f_DSC08040.jpg"
                alt="Notaría Pública 90"
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>

            {/* Content */}
            <div className="order-1 lg:order-2">
              <div className="inline-block bg-notaria-secondary text-white px-4 py-2 rounded-md mb-4 text-sm font-semibold">
                ¿Quiénes somos?
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-notaria-primary mb-6">
                La Notaría 90 es la mejor opción en notarías en Quintana Roo.
              </h1>
              <div className="space-y-4 text-gray-700 text-lg">
                <p>
                  Brindamos una amplia gama de servicios notariales y de asesoría legal, 
                  estudiamos siempre las opciones jurídicas y fiscales más eficientes para 
                  cada cliente y aplicamos en cada momento los valores de honestidad, 
                  integridad y confidencialidad que rigen la actuación de nuestro equipo de 
                  trabajo, de esta manera les garantizamos certeza jurídica a quienes 
                  reclaman la función del notario para que logren los fines lícitos que se 
                  propongan alcanzar.
                </p>
                <p>
                  Siempre velamos por la seguridad preventiva, aseguramos la legalidad y 
                  claridad de las partes implicadas para prevenir conflictos jurídicos futuros; ya 
                  que nuestra principal función es el asesoramiento imparcial y el control 
                  estricto de la calidad.
                </p>
              </div>

              <div className="mt-8 space-y-4">
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-6 h-6 text-notaria-secondary" />
                  <span className="text-gray-800 font-medium">Estrategia y planificación empresarial</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-6 h-6 text-notaria-secondary" />
                  <span className="text-gray-800 font-medium">Eficiencia de procesos y mejora del flujo de trabajo</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold text-notaria-primary mb-4">Nuestra Misión</h3>
                <p className="text-gray-700">
                  Ofrecer servicios notariales de excelencia, garantizando certeza jurídica y 
                  seguridad en cada trámite, mientras aplicamos los más altos estándares de 
                  honestidad, integridad y confidencialidad.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold text-notaria-primary mb-4">Nuestra Visión</h3>
                <p className="text-gray-700">
                  Ser la notaría líder en Quintana Roo, reconocida por nuestra innovación 
                  tecnológica con blockchain y nuestro compromiso con la excelencia en el 
                  servicio notarial.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-notaria-primary mb-12">Nuestros Valores</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-8 h-8 text-notaria-secondary" />
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Honestidad</h4>
                <p className="text-gray-600">
                  Actuamos con transparencia y ética en cada servicio que brindamos.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-8 h-8 text-notaria-secondary" />
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Integridad</h4>
                <p className="text-gray-600">
                  Mantenemos los más altos estándares profesionales y morales.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-8 h-8 text-notaria-secondary" />
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Confidencialidad</h4>
                <p className="text-gray-600">
                  Protegemos la información de nuestros clientes con total seguridad.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TrustedInstitutions title="Nuestros Aliados" subtitle="Instituciones y organismos que trabajan con nosotros y confían en Notaría Pública 90" />
    </div>
  );
};

export default Nosotros;